import React from 'react'
// eslint-disable-next-line no-restricted-imports
import {clientI18n} from '../../../../../code/client/shared/scripts/ClientI18n'
import {TranslationArrayKeys, TranslationKeys, TranslationObject, TranslationOptions} from '@colonist/i18n'

export const t = <T = string>(
    id: TranslationObject | TranslationKeys | TranslationArrayKeys,
    options?: TranslationOptions,
    isArray?: boolean
): T => {
    if(isArray) {
        return clientI18n.tArray<T>(id as TranslationArrayKeys, options)
    }

    if(typeof id === 'string') {
        return clientI18n.t(id as TranslationKeys, options) as T
    } else {
        return clientI18n.t(id.key, id.options) as T
    }
}

export const T = (props: {
    id: TranslationObject | TranslationKeys
    options?: TranslationOptions
}) => <>
    {t(props.id, props.options)}
</>
